/** Shared month labels for MonthYearPicker / range / graduation date. */
export const MONTH_YEAR_MONTHS = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December',
] as const

export type MonthYearMonth = (typeof MONTH_YEAR_MONTHS)[number]
